export const GET_UPCOMING_LAUNCHES = "GET_UPCOMING_LAUNCHES";